import { render, staticRenderFns } from "./mail_setting.vue?vue&type=template&id=6df23788&scoped=true&"
import script from "./mail_setting.vue?vue&type=script&lang=js&"
export * from "./mail_setting.vue?vue&type=script&lang=js&"
import style0 from "./mail_setting.vue?vue&type=style&index=0&id=6df23788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df23788",
  null
  
)

export default component.exports